import React, { useState } from 'react';
import axios from 'axios';
import { Mail, Send, CheckCircle2, Sparkles } from 'lucide-react';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { useToast } from '../hooks/use-toast';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Waitlist = () => {
  const { toast } = useToast();
  const [email, setEmail] = useState('');
  const [city, setCity] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast({ title: 'Email required', description: 'Please enter your email address.' });
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/waitlist`, { email, city: city || null });
      setDone(true);
      toast({ title: 'You are on the list!', description: 'We will notify you as soon as MaLife launches near you.' });
      setEmail('');
      setCity('');
    } catch (err) {
      toast({ title: 'Something went wrong', description: err?.response?.data?.detail || 'Please try again.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-sky-50 via-white to-sky-100 border border-sky-100 p-10 md:p-14">
          <div className="absolute -top-16 -right-16 w-60 h-60 bg-sky-300/30 rounded-full blur-3xl" />
          <div className="absolute -bottom-16 -left-16 w-60 h-60 bg-sky-400/20 rounded-full blur-3xl" />

          <div className="relative text-center max-w-2xl mx-auto">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white border border-sky-200 text-sky-700 text-xs font-semibold tracking-widest uppercase mb-4 shadow-sm">
              <Sparkles className="w-3.5 h-3.5" /> Early access
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#0b2f5c] tracking-tight mb-3">
              Be the first to try MaLife
            </h2>
            <p className="text-slate-600 mb-8 leading-relaxed">
              Drop your email and we’ll let you know the moment MaLife launches in your town.
            </p>

            {done ? (
              <div className="inline-flex items-center gap-2 bg-green-50 border border-green-200 text-green-700 px-5 py-3 rounded-2xl text-sm font-semibold">
                <CheckCircle2 className="w-5 h-5" /> You’re on the list. Ke a leboga!
              </div>
            ) : (
              <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3 max-w-xl mx-auto">
                <div className="relative flex-1">
                  <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                  <Input
                    type="email"
                    placeholder="you@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="pl-10 h-12 border-slate-200 bg-white focus-visible:ring-sky-400"
                    required
                  />
                </div>
                <Input
                  placeholder="City (optional)"
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                  className="sm:w-40 h-12 border-slate-200 bg-white focus-visible:ring-sky-400"
                />
                <Button
                  type="submit"
                  disabled={loading}
                  className="h-12 px-6 bg-[#0b2f5c] hover:bg-[#0f3a70] text-white font-semibold rounded-xl shadow-md"
                >
                  {loading ? 'Joining…' : <>Notify me <Send className="w-4 h-4 ml-2" /></>}
                </Button>
              </form>
            )}

            <p className="text-xs text-slate-500 mt-4">No spam. Just one launch email.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Waitlist;
